import React from 'react'
import SideBar from '../components/SideBar'
import DetailsHeaderBar from '../components/DetailsHeaderBar'
import DetailsTopBar from '../components/DetailsTopBar'
import { useLocation, useNavigate } from 'react-router-dom';
import RequestForm from '../components/RequestForm';

function RequestDetails() {
   const location = useLocation();
    const agent = location.state?.agent;
    const navigate = useNavigate();

     // Define all possible tabs
  const allTabs = [
    {
      key: "personal",
      label: "Personal Details",
      path: "/advertising-agent-details",
    },
    {
      key: "wallet",
      label: "Wallet Details",
      path: "/advertising-agent-wallet-details",
    },
    {
      key: "invitation",
      label: "Invitation Details",
      path: "/advertising-agent-invitation-details",
      showWhen: "approved",
    },
    {
      key: "request",
      label: "Request Details",
      path: "/advertising-agent-request-history",
    },
  ];

  // Filter tabs based on status
  const getTabsByStatus = (agentStatus) => {
    return allTabs.filter((tab) => {
      if (!tab.showWhen) return true; // Always show tabs without conditions
      return tab.showWhen === agentStatus;
    });
  };

  // Usage
  const tabs = getTabsByStatus(agent.status);

    if (!agent) {
        return (
            <div className="member-details-layout">
                <SideBar />
                <div className="member-details-main">
                    <p style={{ padding: "30px" }}>No agent data available.</p>
                </div>
            </div>
        );
    }

  return (
    <div className="member-details-layout">
      <SideBar />
      <div className="member-details-main">
        <DetailsHeaderBar
            title="Advertising Agent Details"
            subtitle="Review and manage agent application"
            breadcrumbs={[
                {label: "Home", path: "/dashboard"},
                {label: "Manage Advertising Agent", path: "/manage-advertising-agent"},
                {label: "Application Review"}
            ]}
        />
        <DetailsTopBar
            tabs={tabs}
            activeTab="request"
            agent={agent}
        />
        <RequestForm agent={agent} />
      </div>
    </div>
  )
}

export default RequestDetails